import { Link } from 'react-router-dom';
import { useState } from 'react';
import './Header.css';

const Header = () => {
    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    };

    return (
        <header className="header">
            <div className="header-container">
                <div className="logo">
                    <Link to="/">
                        <span className="logo-text">AbELab</span>
                    </Link>
                </div>
                
                <nav className="nav">
                    <Link to="/" className="nav-label">Home</Link>
                    
                    <div className="nav-label dropdown">
                        <span className="label-name">About Us</span>
                        <div className="dropdown-content">
                            <Link to="/aboutus-mission" className="nav-button">Our Mission</Link>
                            <Link to="/aboutus-dentistry" className="nav-button">Digital Dentistry</Link>
                        </div>
                    </div>
                    
                    <div className="nav-label dropdown">
                        <span className="label-name">Products</span>
                        <div className="dropdown-content">
                            <Link to="/products/fixed" className="nav-button">Fixed</Link>
                            <Link to="/products/removable" className="nav-button">Removable</Link>
                            <Link to="/products/implants" className="nav-button">Implants</Link>
                            {/* <div className="nav-button nested">
                                <span className="sub-label">Services</span>
                                <div className="sub-dropdown">
                                    <Link to="/services/repair" className="nav-button">Denture Repair</Link>
                                    <Link to="/services/relining" className="nav-button">Denture Relining</Link>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    
                    <Link to="/contacts" className="nav-label">Contacts</Link>
                </nav>
                
                <div className="tel" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                    </svg>
                    +17322309942
                </div>
            </div>
        </header>
    );
};

export default Header;